import { Injectable } from '@angular/core';
import {
    MasterSummaryAnswerModel, MasterSummaryPDModel,
    MasterSummaryQuestionModel,
    SurveyCutQuestionModel,
    SurveyVersionQuestionModel
} from '../../models/survey/survey.model';
import {PercentageType} from '../../shared/constants/percentage.constants';
import Utils from '../../shared/util/Util';

@Injectable()
export class ChartingService {

    undefinedName = 'undefined';

    constructor() {
    }

    /*
        Add ExtraId (random UUID from BE) for each Question Model in response from the back end.
        This purpose helps determine what question input to component Charting after that, we can calculate
        the Percentage (Absolute, Relative) when the theme is on at the Charting component Init
     */
    public updateListAnswerForQuestionWhenThemeIsOn(question: MasterSummaryQuestionModel, survMastSummPDModel: MasterSummaryPDModel,
                                                     questionI: number, chartJ: number, isCompareMode: boolean,
                                                     hasAnswerTheme: boolean, isAllResponses: boolean) {
        if (question.themeModeSelect === true) {
            const data = this.calculatePercentages(survMastSummPDModel, questionI, chartJ,
                            question.themeModeSelect, isCompareMode, hasAnswerTheme, isAllResponses);
            let tempQuestion = data.listQuestionModel.find(x => x.extraId === question.extraId);
            if (tempQuestion) {
                question.listAnswerModel = tempQuestion.listAnswerModel;
            }

            // Cut
            if (survMastSummPDModel.listSurveyCutQuestion && data.listSurveyCutQuestion.length > 0) {
                for (const cutQuestion of data.listSurveyCutQuestion) {
                    tempQuestion = cutQuestion.listQuestionModel.find(x => x.extraId === question.extraId);
                    if (tempQuestion) {
                        question.listAnswerModel = tempQuestion.listAnswerModel;
                    }
                }
            }

            // Version
            if (data.listSurveyVersionQuestion && data.listSurveyVersionQuestion.length > 0) {
                for (const versionQuestion of data.listSurveyVersionQuestion) {
                    tempQuestion = versionQuestion.listQuestionModel.find(x => x.extraId === question.extraId);
                    if (tempQuestion) {
                        question.listAnswerModel = tempQuestion.listAnswerModel;
                    }
                }
            }
        }
    }

    public makeListToEmit(_listAnswerIndexed) {
        const _listToEmit = [];
        for (const key in _listAnswerIndexed) {
            const el: any = _listAnswerIndexed[key];
            _listToEmit.push(el);
        }
        return _listToEmit;
    }

    public groupAnswerForTheme(originalArrayChart, listAnswer?: MasterSummaryAnswerModel[]) {
        const _listToReduce = listAnswer && listAnswer.length > 0
            ? Object.assign([], listAnswer) : Object.assign([], originalArrayChart);
        const acc = [];
        for (const el of _listToReduce) {
            const _answerName = el.answerTheme ? el.answerTheme : this.undefinedName;
            if (acc[_answerName] && acc[_answerName].answerName === _answerName) {
                acc[_answerName].answerCount += el.answerCount;
                acc[_answerName].answerPercentage += el.answerPercentage;
            } else {
                acc[_answerName] = {
                    ...el,
                    answerName: _answerName
                };
            }
        }
        return Object.values(acc);
    }

    private calculatePercentages(survMastSummPDModel, questionI: number, chartJ: number,
                                 _isOnTheme: boolean, isCompareMode: boolean, hasAnswerTheme: boolean, isAllResponses: boolean) {
        if (isCompareMode && hasAnswerTheme && _isOnTheme) {
            const questionIndex = isAllResponses ? chartJ : questionI;
            const [masterChart, data] = this.getMasterObject(survMastSummPDModel, questionIndex, true);
            if (masterChart) {
                const _percentageType = masterChart.typePercentageSelected;
                if (PercentageType.ABSOLUTE === _percentageType) {
                    if (survMastSummPDModel.listSurveyCutQuestion
                        && survMastSummPDModel.listSurveyCutQuestion.length > 0) {
                        this.calculateAllAbsolute(masterChart, data.listSurveyCutQuestion, questionIndex);
                    }
                    if (survMastSummPDModel.listSurveyVersionQuestion
                        && survMastSummPDModel.listSurveyVersionQuestion.length > 0) {
                        this.calculateAllAbsolute(masterChart, data.listSurveyVersionQuestion, questionIndex);
                    }
                    if (survMastSummPDModel.listQuestionModel
                        && survMastSummPDModel.listQuestionModel.length > 0) {
                        this.calculateAllAbsoluteAllResponses(masterChart, data.listQuestionModel, questionIndex);
                    }
                } else if (PercentageType.RELATIVE === _percentageType) {
                    if (survMastSummPDModel.listSurveyCutQuestion
                        && survMastSummPDModel.listSurveyCutQuestion.length > 0) {
                        this.calculateAllRelative(masterChart, data.listSurveyCutQuestion, questionIndex);
                    }
                    if (survMastSummPDModel.listSurveyVersionQuestion
                        && survMastSummPDModel.listSurveyVersionQuestion.length > 0) {
                        this.calculateAllRelative(masterChart, data.listSurveyVersionQuestion, questionIndex);
                    }
                    if (survMastSummPDModel.listQuestionModel
                        && survMastSummPDModel.listQuestionModel.length > 0) {
                        this.calculateAllRelativeAllResponses(masterChart, data.listQuestionModel, questionIndex);
                    }
                }
            }
            return data;
        }
    }

    private getMasterObject(survMastSummPDModel, questionIndex: number, isGroup: boolean) {
        let masterObject: MasterSummaryQuestionModel;
        const data = JSON.parse(JSON.stringify(survMastSummPDModel));
        if (data.listQuestionModel && data.listQuestionModel.length > 0) {
            if (isGroup) {
                data.listQuestionModel[questionIndex].listAnswerModel =
                    this.groupAnswerForTheme(data.listQuestionModel[questionIndex].listAnswerModel);
            }
            if (data.listQuestionModel[questionIndex].diffPercentageSelected === true) {
                masterObject = JSON.parse(JSON.stringify(data.listQuestionModel[questionIndex]));
            }
        }

        // check in list version
        if (data.listSurveyVersionQuestion && data.listSurveyVersionQuestion.length > 0) {
            for (const versionObject of data.listSurveyVersionQuestion) {
                if (isGroup) {
                    versionObject.listQuestionModel[questionIndex].listAnswerModel =
                        this.groupAnswerForTheme(versionObject.listQuestionModel[questionIndex].listAnswerModel);
                }
                if (versionObject.listQuestionModel[questionIndex]
                    && versionObject.listQuestionModel[questionIndex].diffPercentageSelected === true) {
                    masterObject = JSON.parse(JSON.stringify(versionObject.listQuestionModel[questionIndex]));
                }
            }
        }

        // check in list cut
        if (data.listSurveyCutQuestion && data.listSurveyCutQuestion.length > 0) {
            for (const cutObject of data.listSurveyCutQuestion) {
                if (isGroup) {
                    cutObject.listQuestionModel[questionIndex].listAnswerModel =
                        this.groupAnswerForTheme(cutObject.listQuestionModel[questionIndex].listAnswerModel);
                }
                if (cutObject.listQuestionModel[questionIndex]
                    && cutObject.listQuestionModel[questionIndex].diffPercentageSelected === true) {
                    masterObject = JSON.parse(JSON.stringify(cutObject.listQuestionModel[questionIndex]));
                }
            }
        }
        return [masterObject, data];
    }

    // This function return the chose chart based on the input parameters chartJ and questionI and if isCutQuestion or not
    private calculateAllAbsolute(masterChart: MasterSummaryQuestionModel,
                                 listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[], questionIndex: number) {
        let auxChart: MasterSummaryQuestionModel;
        for (let i = 0; i < listQuestion.length; i++) {
            auxChart = listQuestion[i].listQuestionModel[questionIndex];
            this.calculateAbsolute(masterChart, auxChart);
        }
    }

    /*This function will iterate over all chart, and it will call the function to calculate the absolute percentage difference
     *It will also reset the masterChart to not show the percentage difference in that chart
     */
    private calculateAllAbsoluteAllResponses(masterChart: MasterSummaryQuestionModel,
                                             listQuestion: MasterSummaryQuestionModel[], questionIndex: number) {
        this.calculateAbsolute(masterChart, listQuestion[questionIndex]);
    }

    // This function will apply this formula PercentageSibling - PercentageMaster to each question in the charts
    private calculateAbsolute(masterChart: MasterSummaryQuestionModel, siblingChart: MasterSummaryQuestionModel) {
        if (masterChart && siblingChart
            && masterChart.listAnswerModel && siblingChart.listAnswerModel
            && masterChart.extraId !== siblingChart.extraId) {
            siblingChart.typePercentageSelected = PercentageType.ABSOLUTE;
            if (masterChart.listAnswerModel.length > 0 && siblingChart.listAnswerModel.length > 0) {
                for (let i = 0; i < masterChart.listAnswerModel.length && i < siblingChart.listAnswerModel.length; i++) {
                    siblingChart.listAnswerModel[i].answerDiffPercShow = true;
                    const diffPercentage =
                        siblingChart.listAnswerModel[i].answerPercentage - masterChart.listAnswerModel[i].answerPercentage;
                    siblingChart.listAnswerModel[i].answerDiffPercentage = Utils.roundNumber(diffPercentage, 1);
                }
            } else if (masterChart.nizPitanja && siblingChart.nizPitanja
                && masterChart.nizPitanja.length > 0 && siblingChart.nizPitanja.length > 0) {
                for (let i = 0; i < masterChart.nizPitanja.length && i < siblingChart.nizPitanja.length; i++) {
                    siblingChart.nizPitanja[i].answerDiffPercShow = true;
                    const diffPercentage = siblingChart.nizPitanja[i].answerPercentage - masterChart.nizPitanja[i].answerPercentage;
                    siblingChart.nizPitanja[i].answerDiffPercentage = Utils.roundNumber(diffPercentage, 1);
                }
            }
        }
    }

    /*This function will iterate over all chart, and it will call the function to calculate the relative percentage difference
   *It will also reset the masterChart to not show the percentage difference in that chart
   */
    private calculateAllRelative(masterChart: MasterSummaryQuestionModel,
                                 listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[], questionIndex: number) {
        let auxChart: MasterSummaryQuestionModel;
        for (let i = 0; i < listQuestion.length; i++) {
            auxChart = listQuestion[i].listQuestionModel[questionIndex];
            this.calculateRelative(masterChart, auxChart);
        }
    }

    private calculateAllRelativeAllResponses(masterChart: MasterSummaryQuestionModel,
                                             listQuestion: MasterSummaryQuestionModel[], questionIndex: number) {
        this.calculateRelative(masterChart, listQuestion[questionIndex]);
    }

    // This function will apply this formula ((PercentageSibling - PercentageMaster)/PercentageMaster)*100 to each question in the charts
    private calculateRelative(masterChart: MasterSummaryQuestionModel, siblingChart: MasterSummaryQuestionModel) {
        if (masterChart && siblingChart
            && masterChart.listAnswerModel && siblingChart.listAnswerModel
            && masterChart.extraId !== siblingChart.extraId) {
            siblingChart.typePercentageSelected = PercentageType.RELATIVE;
            if (masterChart.listAnswerModel.length > 0 && siblingChart.listAnswerModel.length > 0) {
                for (let i = 0; i < masterChart.listAnswerModel.length && i < siblingChart.listAnswerModel.length; i++) {
                    siblingChart.listAnswerModel[i].answerDiffPercShow = true;
                    const masterPercentage = masterChart.listAnswerModel[i].answerPercentage;
                    siblingChart.listAnswerModel[i].answerDiffPercentage = 0.0;
                    const numerator = siblingChart.listAnswerModel[i].answerPercentage - masterPercentage;
                    if (masterPercentage !== 0) {
                        const diffPercentage = (numerator / masterPercentage) * 100;
                        siblingChart.listAnswerModel[i].answerDiffPercentage = Utils.roundNumber(diffPercentage, 1);
                    } else if (masterPercentage === 0 && numerator !== 0) {
                        siblingChart.listAnswerModel[i].answerDiffPercShow = false;
                        siblingChart.listAnswerModel[i].answerDiffPercentage = null;
                    }
                }
            } else if (masterChart.nizPitanja && siblingChart.nizPitanja
                && masterChart.nizPitanja.length > 0 && siblingChart.nizPitanja.length > 0) {
                for (let i = 0; i < masterChart.nizPitanja.length && i < siblingChart.nizPitanja.length; i++) {
                    siblingChart.nizPitanja[i].answerDiffPercShow = true;
                    const masterPercentage = masterChart.nizPitanja[i].answerPercentage;
                    siblingChart.nizPitanja[i].answerDiffPercentage = 0.0;
                    const numerator = siblingChart.nizPitanja[i].answerPercentage - masterPercentage;
                    if (masterPercentage !== 0) {
                        const diffPercentage = (numerator / masterPercentage) * 100;
                        siblingChart.nizPitanja[i].answerDiffPercentage = Utils.roundNumber(diffPercentage, 1);
                    } else if (masterPercentage === 0 && numerator !== 0) {
                        siblingChart.nizPitanja[i].answerDiffPercShow = false;
                        siblingChart.nizPitanja[i].answerDiffPercentage = null;
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/charting.service.ts